import { jsx as _jsx } from "react/jsx-runtime";
import { Box, CircularProgress } from "@mui/material";
export const LoadingScreen = () => (_jsx(Box, Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100vw" }, { children: _jsx(CircularProgress, {}) })));
export default LoadingScreen;
